/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { SubscriptionTier } from './SubscriptionTier';
import {
    SubscriptionTierFromJSON,
    SubscriptionTierFromJSONTyped,
    SubscriptionTierToJSON,
    SubscriptionTierToJSONTyped,
} from './SubscriptionTier';

/**
 * 
 * @export
 * @interface GetSubscriptionTiersResponse
 */
export interface GetSubscriptionTiersResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetSubscriptionTiersResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<SubscriptionTier>}
     * @memberof GetSubscriptionTiersResponse
     */
    subscriptionTiers: Array<SubscriptionTier>;
}

/**
 * Check if a given object implements the GetSubscriptionTiersResponse interface.
 */
export function instanceOfGetSubscriptionTiersResponse(value: object): value is GetSubscriptionTiersResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('subscriptionTiers' in value) || value['subscriptionTiers'] === undefined) return false;
    return true;
}

export function GetSubscriptionTiersResponseFromJSON(json: any): GetSubscriptionTiersResponse {
    return GetSubscriptionTiersResponseFromJSONTyped(json, false);
}

export function GetSubscriptionTiersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSubscriptionTiersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'subscriptionTiers': ((json['subscriptionTiers'] as Array<any>).map(SubscriptionTierFromJSON)),
    };
}

export function GetSubscriptionTiersResponseToJSON(json: any): GetSubscriptionTiersResponse {
    return GetSubscriptionTiersResponseToJSONTyped(json, false);
}

export function GetSubscriptionTiersResponseToJSONTyped(value?: GetSubscriptionTiersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'subscriptionTiers': ((value['subscriptionTiers'] as Array<any>).map(SubscriptionTierToJSON)),
    };
}

